import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import JardinsVerticais from './pages/JardinsVerticais';
import Paisagismo from './pages/Paisagismo';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/jardins-verticais" element={<JardinsVerticais />} />
        <Route path="/paisagismo" element={<Paisagismo />} />
      </Routes>
    </Router>
  );
}

export default App;
